const employeeCostsSettingsLinks: any[] = [
  {
    label: "UPDATE_EMPLOYEE_MONTHLY_COSTS",
    capability: "update_employee_monthly_costs",
    url: "/dashboard/update-employee-costs",
    section: "update_data",
  },
  {
    label: "LIST_EMPLOYEE_MONTHLY_COSTS",
    capability: "view_employee_monthly_costs",
    url: "/dashboard/list-employee-costs",
    section: "administration",
  },
  {
    label: "UPDATE_EMPLOYEE_CONTRACT_COSTS",
    capability: "update_employee_contract_costs",
    url: "/dashboard/update-employees-contracts-costs",
    section: "update_data",
  },
  {
    label: "UPDATE_EMPLOYEE_TFR_AMOUNT",
    capability: "update_employee_tfr_amount",
    url: "/dashboard/update-employees-tfr-amount",
    section: "update_data",
  },
];

export default employeeCostsSettingsLinks;
